// extracted by mini-css-extract-plugin
export var copyIcon = "_sn-2";
export var discountCard = "_sn-0";
export var discountCode = "_sn-3";
export var discountContent = "_sn-1";
export var loadingCard = "_sn-4";